module.exports = __webpack_public_path__ + "img/Bitmap1.2b3de36c.png";